module.exports = __webpack_public_path__ + "static/img/enfeihuaibao.1b4206f0.png";